/**
 * EventObject.ts
 *
 * Passed around by EventBus to trigger state changes.
 *
 * Static objects that wrap a string and occasionally a value.
 * @see {@link EventBus}
 * @see {@link https://www.typescriptlang.org/docs/handbook/utility-types.html#recordkeys-type}
 */
export class EventObject {
    constructor(type, payload) {
        this.type = type;
        this.payload = payload;
    }
    getType() {
        return this.type;
    }
    /**
     * @returns `payload`.
     */
    getCurrentTarget() {
        return this.payload;
    }
    setPayload(payload) {
        this.payload = payload;
    }
    /**
     * @deprecated Use `getCurrentTarget()`.
     * @returns `payload`.
     */
    getPayload() {
        return this.payload;
    }
}
//# sourceMappingURL=EventObject.js.map